import React from "react";

const AdBanner = () => {
  return (
    <div
      style={{
        backgroundColor: "#fef6f2",
        borderRadius: "8px",
        padding: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "20px 0",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* "Ad" label */}
      <span
        style={{
          position: "absolute",
          top: "5px",
          right: "10px",
          backgroundColor: "#fff",
          padding: "2px 6px",
          fontSize: "10px",
          fontWeight: "bold",
          borderRadius: "5px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        }}
      >
        Ad
      </span>

      {/* Main content */}
      <div style={{ textAlign: "center", width:"100%" }}>
        <p style={{ marginBottom: "8px", fontWeight: "500" }}>
          Advertise your brand here!
        </p>
        {/* Logos */}
        <div style={{ display: "flex", justifyContent: "center", gap: "15px", flexWrap: "wrap" }}>
          
        </div>
      </div>
    </div>
  );
};

export default AdBanner;
